/* RESPONSIBLE TEAM: team-frontend-tech */
import { tracked } from '@glimmer/tracking';
import storage from 'embercom/vendor/intercom/storage';

interface RequiredScrollSettings {
  mouseWheelFactor: number;
  inScrollWheelZoomMode: boolean;
}

interface OptionalScrollSettings {
  mouseWheelFactor?: number;
  inScrollWheelZoomMode?: boolean;
}

const IN_SCROLL_WHEEL_ZOOM_MODE_KEY = 'graph_editor_in_scroll_wheel_zoom_mode';

class ScrollSettings {
  mouseWheelFactor: number;
  @tracked inScrollWheelZoomMode: boolean;

  constructor({ mouseWheelFactor, inScrollWheelZoomMode }: RequiredScrollSettings) {
    this.mouseWheelFactor = mouseWheelFactor;
    this.inScrollWheelZoomMode =
      storage.get(IN_SCROLL_WHEEL_ZOOM_MODE_KEY) || inScrollWheelZoomMode;
  }

  toggleScrollWheelZoomMode(): void {
    this.inScrollWheelZoomMode = !this.inScrollWheelZoomMode;
    storage.set(IN_SCROLL_WHEEL_ZOOM_MODE_KEY, this.inScrollWheelZoomMode);
  }
}

const DEFAULT_SCROLL_SETTINGS: RequiredScrollSettings = {
  mouseWheelFactor: 0.1,
  inScrollWheelZoomMode: false,
};

export {
  ScrollSettings,
  OptionalScrollSettings,
  DEFAULT_SCROLL_SETTINGS,
  IN_SCROLL_WHEEL_ZOOM_MODE_KEY,
};
